var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 10C34.875 10 34.75 10.0625 34.625 10.125L24 14L23.3125 13.8125C24.8125 11.625 26 9.375 26 7.6875C26 3.4375 22.375 0 18 0C13.5625 0 10 3.5 10 7.6875C10 8.4375 10.25 9.3125 10.625 10.25L1.25 13.5C0.5 13.8125 0 14.5625 0 15.375V31C0 31.625 0.4375 32 1 32C1.125 32 1.25 32 1.375 31.9375L12 28L22.75 31.8125C23.5625 32.0625 24.4375 32.125 25.25 31.8125L34.6875 28.5C35.5 28.25 36 27.5 36 26.6875V11C36 10.4375 35.5 10 35 10ZM11 26.25L1.9375 29.5625L1.875 15.4375L11 12.25V26.25ZM18 2C21.25 2 24 4.5625 24 7.6875C24 9.375 21.5625 13.25 18 17.5C14.375 13.25 12 9.375 12 7.6875C12 4.5625 14.6875 2 18 2ZM23 29.8125L13 26.25V14.3125C14.5 16.5625 16.25 18.5625 17.1875 19.6875C17.375 19.9375 17.6875 20 18 20C18.25 20 18.5625 19.9375 18.75 19.6875C19.5625 18.75 20.875 17.25 22.125 15.5L23 15.8125V29.8125ZM25 29.8125V15.8125L34 12.4375L34.0625 26.625L25 29.8125ZM19.5 8C19.5 7.1875 18.8125 6.5 18 6.5C17.125 6.5 16.5 7.1875 16.5 8C16.5 8.875 17.125 9.5 18 9.5C18.8125 9.5 19.5 8.875 19.5 8Z",
    fill: "#97AEB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.e356c2f029900a80bcb2b78913641596.svg";
export { ForwardRef as ReactComponent };